// Version : 0.0.1
// Author : Vignesh
// LastEdit : Vignesh
// Last Add : 'Removed unused Actions'
// Modified Date : 23-08-2025
import JournalTransactionActionTypes from './journal-transaction.types';

/** ***************** GET JOURNAL TRANSACTION VOUCHER COUNT START *********************** */

export const getVoucherCountStart = (getData: any) => ({
	type: JournalTransactionActionTypes.FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_START,
	payload: getData,
});
export const getVoucherCountSuccess = (successData: any) => ({
	type: JournalTransactionActionTypes.FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_SUCCESS,
	payload: successData,
});

export const getVoucherCountFailure = (failureData: any) => ({
	type: JournalTransactionActionTypes.FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_FAILURE,
	payload: failureData,
});
export const getVoucherDetailsResponseChanged = () => ({
	type: JournalTransactionActionTypes.FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_RESPONSE_CHANGED,
});

export const getVoucherDetailsResponseReset = () => ({
	type: JournalTransactionActionTypes.FETCH_JOURNAL_TRANSACTION_VOUCHER_COUNT_RESPONSE_RESET,
});

/** ***************** GET JOURNAL TRANSACTION VOUCHER COUNT END *********************** */

/** ***************** GET PARTICULAR ACCOUNT DETAILS START *********************** */
export const getParticularAccountDetailsStart = (payload: any) => ({
	type: JournalTransactionActionTypes.FETCH_PARTICULAR_ACCOUNT_DETAILS_START,
	payload,
});

export const getParticularAccountDetailsSuccess = (response: any) => ({
	type: JournalTransactionActionTypes.FETCH_PARTICULAR_ACCOUNT_DETAILS_SUCCESS,
	payload: response,
});

export const getParticularAccountDetailsFailure = (error: any) => ({
	type: JournalTransactionActionTypes.FETCH_PARTICULAR_ACCOUNT_DETAILS_FAILURE,
	payload: error,
});

export const getParticularAccountDetailsResponseChanged = () => ({
	type: JournalTransactionActionTypes.FETCH_PARTICULAR_ACCOUNT_DETAILS_RESPONSE_CHANGED,
});

export const getParticularAccountDetailsResponseReset = () => ({
	type: JournalTransactionActionTypes.FETCH_PARTICULAR_ACCOUNT_DETAILS_RESPONSE_RESET,
});
/** ***************** GET PARTICULAR ACCOUNT DETAILS END *********************** */

/** ***************** CREATE JOURNAL ENTRY START *********************** */

export const createJournalEntryStart = (payload: any) => ({
	type: JournalTransactionActionTypes.CREATE_JOURNAL_ENTRY_START,
	payload,
});

export const createJournalEntrySuccess = (payload: any) => ({
	type: JournalTransactionActionTypes.CREATE_JOURNAL_ENTRY_SUCCESS,
	payload,
});

export const createJournalEntryFailure = (payload: any) => ({
	type: JournalTransactionActionTypes.CREATE_JOURNAL_ENTRY_FAILURE,
	payload,
});

export const createJournalEntryResponseChanged = () => ({
	type: JournalTransactionActionTypes.CREATE_JOURNAL_ENTRY_RESPONSE_CHANGED,
});

export const createJournalEntryResponseReset = () => ({
	type: JournalTransactionActionTypes.CREATE_JOURNAL_ENTRY_RESPONSE_RESET,
});

/** ***************** CREATE JOURNAL ENTRY END *********************** */

/** ***************** UPDATE JOURNAL TRANSACTIONS START *********************** */

export const updateJournalEntryStart = (payload: any) => ({
	type: JournalTransactionActionTypes.UPDATE_JOURNAL_ENTRY_START,
	payload,
});

export const updateJournalEntrySuccess = (payload: any) => ({
	type: JournalTransactionActionTypes.UPDATE_JOURNAL_ENTRY_SUCCESS,
	payload,
});

export const updateJournalEntryFailure = (payload: any) => ({
	type: JournalTransactionActionTypes.UPDATE_JOURNAL_ENTRY_FAILURE,
	payload,
});

export const updateJournalEntryResponseChanged = () => ({
	type: JournalTransactionActionTypes.UPDATE_JOURNAL_ENTRY_RESPONSE_CHANGED,
});

export const updateJournalEntryResponseReset = () => ({
	type: JournalTransactionActionTypes.UPDATE_JOURNAL_ENTRY_RESPONSE_RESET,
});

/** ***************** UPDATE JOURNAL TRANSACTIONS END *********************** */
